export default "__VITE_ASSET__DmEectUj__"